import { render } from "./LbrxKioskFifthTheme.vue?vue&type=template&id=8d98b014&scoped=true"
import script from "./LbrxKioskFifthTheme.vue?vue&type=script&lang=js"
export * from "./LbrxKioskFifthTheme.vue?vue&type=script&lang=js"

import "./LbrxKioskFifthTheme.vue?vue&type=style&index=0&id=8d98b014&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d98b014"]])

export default __exports__